import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { Link as RouterLink } from 'react-router-dom';

import {
    Autocomplete,
    Card, CardContent,
    CardHeader, Checkbox, Divider, Grid, Link, Table,
    TableBody,
    TableCell, TableRow, TextField, Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { ContattoContext } from '../ContattoContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';



const LinkRouter = props => <Link {...props} component={RouterLink} />;

const ContattoSchema = Yup.object().shape({
    tipoContattoId: Yup.number().required("Il tipo attributo è un campo obbligatorio"),
    descrizione: Yup.string().required("La descrizione è un campo obbligatorio"),
    valore: Yup.string().required("Il valore è un campo obbligatorio"),
    ordine: Yup.number().required("L'ordine è un campo numerico obbligatorio"),
});

export const ContattoForm = ({
    disabled,
    formRef,
    onActionClick,
    ...props }) => {

    const {
        state,
        setState,
    } = useContext(ContattoContext);

    const {
        contatto,
        tipiContatti,
        tipiContattiOptions
    } = state;

    const {
        ufficioId,
        contattoId,
    } = useParams();

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        id: contatto?.id ?? 0,
                        padreId: contatto?.padreId ?? null,
                        ufficioId: contatto?.ufficioId ?? ufficioId,
                        tipoContattoId: contatto?.tipoContattoId ?? null,
                        descrizione: contatto?.descrizione ?? "",
                        valore: contatto?.valore ?? "",
                        testoGrassetto: contatto?.testoGrassetto ?? false,
                        testoCorsivo: contatto?.testoCorsivo ?? false,
                        testoCollegamento: contatto?.testoCollegamento ?? false,
                        linkCollegamento: contatto?.linkCollegamento ?? "",
                        ordine: contatto?.ordine ?? 0,
                        inizioValidita: contatto?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: contatto?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={ContattoSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Tipo attributo
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="tipoContattoId"
                                                            component={Autocomplete}
                                                            options={tipiContattiOptions}
                                                            onChange={(e, value) => {
                                                                setFieldValue('tipoContattoId', value?.tipoContattoId)
                                                                setFieldValue('descrizione', tipiContatti.result.find(x => x.id == value?.tipoContattoId).nome);
                                                                setFieldValue('testoGrassetto', tipiContatti.result.find(x => x.id == value?.tipoContattoId).testoGrassettoDefault);
                                                                setFieldValue('testoCorsivo', tipiContatti.result.find(x => x.id == value?.tipoContattoId).testoCorsivoDefault);
                                                                setFieldValue('testoCollegamento', tipiContatti.result.find(x => x.id == value?.tipoContattoId).testoCollegamentoDefault);
                                                            }}
                                                            value={tipiContattiOptions.find(option => option.tipoContattoId == values.tipoContattoId) ?? null}
                                                            renderInput={(params) => <TextField {...params} label="Scegli..." />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Descrizione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="descrizione"
                                                            name="descrizione"
                                                            value={values.descrizione}
                                                            onChange={handleChange}
                                                            error={touched.descrizione && Boolean(errors.descrizione)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Valore
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="valore"
                                                            name="valore"
                                                            value={values.valore}
                                                            onChange={handleChange}
                                                            error={touched.valore && Boolean(errors.valore)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                {
                                                    values.testoCollegamento &&
                                                    <TableRow>
                                                        <TableCell style={{ width: "20%" }}>
                                                            Link collegamento
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth
                                                                id="linkCollegamento"
                                                                name="linkCollegamento"
                                                                value={values.linkCollegamento}
                                                                onChange={handleChange}
                                                                error={touched.linkCollegamento && Boolean(errors.linkCollegamento)}
                                                                inputProps={{ sx: { padding: 1 } }} />
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo grassetto default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoGrassetto"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoGrassetto', e.target.checked);
                                                            }}
                                                            checked={values.testoGrassetto}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo corsivo default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoCorsivo"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoCorsivo', e.target.checked);
                                                            }}
                                                            checked={values.testoCorsivo}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo collegamento default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoCollegamento"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoCollegamento', e.target.checked);
                                                            }}
                                                            checked={values.testoCollegamento}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Ordine
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="ordine"
                                                            name="ordine"
                                                            value={values.ordine}
                                                            onChange={handleChange}
                                                            error={touched.ordine && Boolean(errors.ordine)}
                                                            inputProps={{ sx: { padding: 1 } }}
                                                            type='number' />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={contatto?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={contatto?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={contatto?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={contatto?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}